import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { hasAdminAccess } from "utils/access";

const useHasSpaceAdminAccess = (spaceId?: string) => {
  const { viewer } = useTypedContext(AccountContext);

  if (!spaceId) {
    return false;
  }

  return hasAdminAccess(viewer, spaceId);
};

export default useHasSpaceAdminAccess;
